<template>
  <div class="rf-segment-sub-content p-4">
    <div class="mb-3 flex items-center justify-between">
      <h4>History</h4>
      <RouterLink
        v-if="userStore.isUserSuperAdmin && auditableType && auditableId"
        class="text-buttons inline-flex items-center gap-1 text-blue-50"
        :to="{
          path: '/audits',
          query: { associated_type: auditableType, associated_id: auditableId },
        }"
      >
        View all
      </RouterLink>
    </div>
    <div class="rf-history-list">
      <div
        v-for="item in activities"
        :key="`${item.time}-${item.action}-${item.object_id}`"
        class="history-event-item"
      >
        <div class="history-colm-1">
          <template v-if="item.summary">
            {{
              `${item.display_object_type}:${item.object_name ? ` ${item.object_name}` : ""} ${item.summary}`
            }}
          </template>
          <template v-else-if="item.object_type !== 'Path'">
            {{ `${item.display_object_type} was ${item.display_action}` }}
          </template>
          <template v-else>
            <div>Event: {{ item.action }}</div>
            <div v-if="item.updated_fields?.length">
              Items Updated: {{ item.updated_fields.join(", ") }}
            </div>
          </template>
        </div>
        <div class="history-colm-2">
          <div class="history-ct-name">{{ item.name }}</div>
          <div class="history-ct-date">
            {{ dayjs(item.time).format("MMM Do YYYY, h:mm a") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import { RouterLink } from "vue-router";
import { useUserStore } from "@/pinia/userStore";

const userStore = useUserStore();

defineProps({
  activities: Array,
  auditableType: { type: String, default: null },
  auditableId: { type: [String, Number], default: null },
});
</script>

<style scoped>
.rf-history-list {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.history-event-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
  border-bottom: 1px dotted #ddd;
  padding: 10px;
  &:last-child {
    border-bottom: 0;
  }
  .history-colm-1 {
    width: 60%;
  }
  .history-colm-2 {
    width: 40%;
    text-align: right;
  }
  .history-ct-name {
    font-weight: 500;
  }
  .history-ct-date {
    font-size: 0.9em;
    color: #999;
  }
}
</style>
